export default __webpack_public_path__ + "static/media/ps_controller.df779443.png";